import {InjectSVGLazy} from 'app/modules/injectSVG/lazy';
import {getWebComponentLoader} from 'app/utils/initialize/getWebComponentLoader';

export function defineInjectSVG(WebComponentLoader: ReturnType<typeof getWebComponentLoader>) {
    if (customElements.get('gem-inject-svg')) {
        return;
    }

    customElements.define(
        'gem-inject-svg',
        class extends WebComponentLoader {
            reactLazyComponent = InjectSVGLazy;
            hasConfig = false;
        },
    );
}
